function getReadTimeWithDefault(minutes) {
  const numberOfMinutes = Number(minutes);
  return numberOfMinutes > 0 ? numberOfMinutes : 5;
}
export {
  getReadTimeWithDefault
};
